import React from 'react';
import './index.css';
import App from './App';
import * as ReactDOM from "react-dom";


ReactDOM.render(<App/>, document.getElementById('root'));

